import { useContext } from 'react'
import { ModalContext, ModalContextType } from '../../../context/ModalContext'
import { ConfigContext, useTranslation } from '../../../context/ConfigContext'
import { useIsMobileOrTablet } from '../../../utils/screen.utils'
import { Button } from '../../Button/Button'
import ModalContact from '../../Modal/ModalContact'

export default function ContactConciergerieCta() {
  const isTablet = useIsMobileOrTablet()
  const t = useTranslation()
  const { addModal } = useContext(ModalContext) as ModalContextType
  const { storeConfig } = useContext(ConfigContext)
  const tel = storeConfig.general_store_information_phone?.replace(/\s/g, '')
  return (
    <Button
      type='button'
      classname='small black'
      style='dark'
      href={isTablet ? `tel:${tel}` : undefined}
      onClick={(ev) => {
        if (!isTablet) {
          ev.preventDefault()
          const uuid = crypto.randomUUID()
          addModal({
            uuid,
            component: <ModalContact uuid={uuid} />,
          })
        }
      }}>
      {t('cms-service-contact-text')}
    </Button>
  )
}
